import { Injectable } from "@angular/core";
import { StorageService } from "../../storage/storage.service";

@Injectable({
  providedIn: "root",
})
export class HierarchyManagementService {
  constructor(private storageService: StorageService) {}

  getHierarchyStored(): any {
    return this.storageService.getSessionStorage("hierarchy");
  }

  setHierarchyOnStore(defineArrayForRecursion): void {
    this.storageService.setSessionStorage("hierarchy", defineArrayForRecursion);
  }

  setHierarchySelectedForTree(hierarchySelected): void {
    this.storageService.setSessionStorage(
      "hierarchy_selected_tree",
      hierarchySelected
    );
  }

  clearHierarchy() {
    this.storageService.setSessionStorage("hierarchy", "");
    this.storageService.setSessionStorage("hierarchy_selected_tree", "");
    this.storageService.setSessionStorage("hierarchy_selected", "");
    this.storageService.setSessionStorage("hierarchy_selected_refs", "");
    this.storageService.setSessionStorage("hierarchy_with_name","");
  }

  getHierarchySelectedForTree(): any {
    return this.storageService.getSessionStorage("hierarchy_selected_tree");
  }

  getHierarchySelectedWithName(): any {
    return this.storageService.getSessionStorage("hierarchy_with_name");
  }
  setHierarchyIdsSelectedWithName(Hierarchy): void {
    this.storageService.setSessionStorage("hierarchy_with_name", Hierarchy);
  }

  setHierarchyIdsSelected(hierarchyIds): void {
    this.storageService.setSessionStorage("hierarchy_selected", hierarchyIds);
  }

  setHierarchyRefsSelected(hierarchyIds): void {
    this.storageService.setSessionStorage(
      "hierarchy_selected_refs",
      hierarchyIds
    );
  }

  getHierarchyRefs(): any {
    return this.storageService.getSessionStorage("hierarchy_selected_refs");
  }

  getHierarchyIds(): any {
    return this.storageService.getSessionStorage("hierarchy_selected");
  }
}
